import { css } from "@emotion/react"
import styled from "@emotion/styled"

const dinamicStyles = ({ theme, lowerText }) => css`
  ${lowerText &&
  `
    ${theme.breakpoints.down("xl")} {
      margin-bottom: 79px; 
    }

    ${theme.breakpoints.between("xl", "2xl")} {
      margin-bottom: 94px;  
    }

    ${theme.breakpoints.up("2xl")} {
      margin-bottom: 137px;  
    }
  `}
`

const ListFiveStack = styled.div`
  margin-left: auto;
  margin-right: auto;
  ${dinamicStyles}

  ${({ theme }) => theme.breakpoints.down("xl")} {
    padding-top: 50px;
  }

  ${({ theme }) => theme.breakpoints.down("sm")} {
    max-width: 344px;
  }

  ${({ theme }) => theme.breakpoints.between("sm", "lg")} {
    max-width: 500px;
  }

  ${({ theme }) => theme.breakpoints.between("lg", "xl")} {
    max-width: 750px;
  }
`

export default ListFiveStack
